import { httpClient } from '@/services/httpClient';

const getRoles = async () => {
    try {
        const response = await httpClient.get('/api/v1/users/roles')

        return response.data
    } catch (error) {
        throw error; 
    }
}

export { 
    getRoles, 
} 